import React, { useRef, useState, useEffect } from 'react';
import EmailTemplateTable from './EmailTemplateTable';
import { Button, Spinner } from 'react-bootstrap';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router-dom';
import { showToast } from '../../Utills/toast';


const EmailTemplateSetting = () => {
  const { partnerId, id:templateId } = useParams();

  const [editRow, setEditRow] = useState(null);
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);


  const handleEdit = (row) => {
  navigate(`/${partnerId}/email-template-settings/${row.id}`);
  };

  const handleBack = () => {
    navigate(`/${partnerId}/email-template-settings`);
  };

  const toPascalCase = (str) => {
    if (!str) return '';
    return str
      .replace(/-/g, ' ') // Replace dashes with spaces
      .replace(/\w\S*/g, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      );
  }

  const handleSaveClick = async () => {
    if (isSaving) return;
    try {
      setIsSaving(true);
      if (componentRef.current) {
        await componentRef.current.saveTemplate()
      } else {
        console.log("componentRef.current is null");
      }
    } catch (error) {
      console.error('Error saving template:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (

    <div className="p-2 p-md-4 p-sm-3">
      <div className={`${templateId ? 'justify-content-between' : 'justify-content-center'} d-flex gap-2 mb-md-3 mb-sm-2 mb-1 w-100 `}>
      <div className='d-flex gap-2'>
        {templateId && <div>
            <Button variant="contained" onClick={handleBack} className='w-auto m-0 border-0 p-0'><AiOutlineArrowLeft fill='#0d6efd'/></Button>
          </div>}
          <h2 className="fs-5 mb-0">
            {templateId ? (
              <div className='fs-5'>
                <div>Edit {editRow?.name ? toPascalCase(editRow?.name) + ' Template' : 'Email Template Settings'}</div>
                <div className='fw-normal mt-1' style={{fontSize:'12px',color:'#6c757d'}}>{editRow?.subject ? editRow?.subject : '-'}</div>
              </div>
            ) : 'Email Template Settings'}
          </h2>
      </div>
      {templateId && <div className={"d-flex items-center justify-content-end space-x-4"}>
            <Button className='w-auto mx-0 mb-2' color={"primary"} size={"md"} onClick={handleSaveClick} style={{border:'none',height:'fit-content'}}>
              {isSaving ? (
                <div className="d-flex align-items-center">
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                </div>
              ) : (
                'Save'
              )}
            </Button>
          </div>}
      </div>
      <EmailTemplateTable 
        handleEdit={handleEdit} 
        editRow={editRow} 
        setEditRow={setEditRow}
        handleBack={handleBack}
        ref={componentRef}
      />
    </div>
  );
};

export default EmailTemplateSetting;